import requests from "./httpService";
 
const DashboardServices = {
    getAccountsSaleStats : async (body) => {
        return requests.get(`/dashboard/accounts/sale-stats/`);
      },
    getRecentSales : async (body) => {
        return requests.get(`/dashboard/accounts/sale-recent/`);
    },
    getDashboardGraphSale : async (type) => {
        return requests.get(`/dashboard/accounts/sale-graphstats/${type}`);
    },
    getDashboardGraphPurchase : async (type) => {
        return requests.get(`/dashboard/accounts/purchase-graphstats/${type}`);
    },
    getTransportGraph : async (type,employeeId) => {
        return requests.get(`/dashboard/transmanager/graph-stats/${type}/${employeeId}`);
    },
    getDashboardGraphCare : async (type,employeeId) => {
        return requests.get(`/dashboard/care/escalate-graph/${type}/${employeeId}`);
    },
    getProfileDashboard : async (id, body) => { 
        return requests.get(`/dashboard/profile/${id}`, body);
    }
}
 
export default DashboardServices;
 